export const isValidObject = (item) => {
  return item && typeof item === 'object'
}

export const isValidDate = (date) => {
  const formattedDate = date ? new Date(date) : date
  return formattedDate instanceof Date && !isNaN(formattedDate)
}
